<template>
  <div class="page">
    <!-- header -->
    <header-bar :selected="selected" :cityName="cityName" @getCityId="getCityId"></header-bar>
    <!-- container -->
    <div class="container">
      <!-- 步骤条 -->
      <el-steps :active="4" align-center>
        <el-step title="选择影片场次"></el-step>
        <el-step title="选择座位"></el-step>
        <el-step title="付款"></el-step>
        <el-step title="影院取票观影"></el-step>
      </el-steps>
      <!-- 倒计时 -->
      <div class="count-down-wrapper">
        <div class="count-down">
          <div class="time-left">{{codeMsg}}</div>
          <div class="tip">
            <span>{{order.ticketCode}}</span>
            <p class="verify" v-if="order.verifyCode"><span>{{order.verifyCode}}</span></p>
          </div>
        </div>
      </div>
      <div class="orderid-box">
          <span class="orderid">看购订单号：{{orderId}}</span>
          <span class="desc">（有订单问题可拨打看购客服电话<i>400-6776-501</i>，工作时间: 9:00-18:00）</span>
        </div>
      <table class="order-table">
        <thead>
          <tr>
            <th>影片</th>
            <th>时间</th>
            <th>影院</th>
            <th>座位</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="movie-name">《{{order.mall_name}}》</td>
            <td class="showtime">{{order.show_date}} {{order.show_time}}</td>
            <td class="cinema-name">{{order.cinema_name}}</td>
            <td>
              <div class="seats">
                <span class="seat">{{order.seatId}}</span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="confirm-wrapper">
        <div class="buy-btn">
          <span class="btn" @click="toOrderDetail()">查看详情</span>
        </div>
        <!-- <div class="price-wrapper">
          <span>总价 :</span>
          <span class="prices"><span class="price">{{order.totalPrice}}</span></span>
        </div> -->
      </div>
    </div>
    <!-- footer -->
    <footer-bar></footer-bar>
  </div>
</template>

<script>
  import headerBar from '@/components/headerBar'
  import footerBar from '@/components/footerBar'
  import {payResult} from '@/api/order'

  export default {
    components: {headerBar, footerBar},
    data(){
      return{
        // 订单id
        orderId: this.$route.query.orderId,
        // orderId: "21052641484267743312",
        // 选中的当前导航
        selected: "",
        // 城市名称
        cityName: '',
        //订单信息
        order: {},
        qrCode: '',
        timerFalg: true,
        timer: '', //定时器
        codeMsg: '出票成功，待消费',
        sendMsg: '',
        
      }
    },
    mounted() {
      //保证this实例已经插入文档
      this.$nextTick(function(){
        // 获取城市名称
        this.cityName = localStorage.getItem('cityName');
        // 数据
        this.getOrder();
      })
    },
    methods: {
      // 获取子组件（headerBar）传递的值
      getCityId(cityId){
        this.cityId = cityId;
        this.cityName = localStorage.getItem("cityName");
      },
      // 获取数据
      getOrder() {
      	let signdata = {orderId: this.orderId};
        let data = {orderId: this.orderId, signdata: signdata};
        payResult(data).then(response => {
          this.order = response.data;
          //状态0=成功,1=失败,2=退款
          let status = response.data.status;
          //已退款
          if ('2' == status) {
            this.codeMsg = '出票失败,已退款处理'
            clearInterval(this.timer);
          }
          //出票失败
          else if ('1' == status) {
            this.codeMsg = '出票失败,已安排退款'
            clearInterval(this.timer);
          } else {
            //二维码
            let qrCode = response.data.qrCode;
            this.qrCode = qrCode;
            //如果取票码有值，清除定时器
            if ('' != qrCode && null != qrCode) {
              clearInterval(this.timer);
            }
            //如果取票码无值,指定定时器
            else if (this.timerFalg) {
              this.timerFalg = false;
              this.codeMsg = '正在生成取票码';
              // 定时器----获取取票码
              var i = setInterval(this.getOrder, 2000)
              this.timer = i;
            }
          }
        });
      },
      // 跳转到订单详情
      toOrderDetail() {
        this.$router.push({path: '/orderDetail', query: {orderId: this.orderId}})
      },
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .container {
    margin-top: 120px;
    margin-left: auto;
    margin-right: auto;
    padding-bottom: 30px;
    width: 75%;
  }
  .count-down-wrapper {
    display: flex;
    align-items: center;
    margin-top: 40px;
    width: 100%;
    height: 90px;
    margin-bottom: 40px;
    background-color: #f4fff6;
    text-align: left;
  }
  .count-down-wrapper .count-down {
    padding-left: 55px;
    min-height: 40px;
    margin-left: 30px;
    background: url('data:image/png;base64,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') no-repeat;
    background-position: 0 50%;
    background-size: 40px 40px;
  }
  .count-down-wrapper .time-left {
    font-size: 20px;
    font-weight: bold;
    color: #38df75;
    margin-bottom: 4px;
  }
  .count-down-wrapper .time-left .minute {
    margin: 0 5px;
    font-size: 32px;
    color: #f03d37;
  }
  .count-down-wrapper .tip {
    font-size: 14px;
    color: #999;
  }
  .count-down-wrapper .tip .verify{
    display: inline-block;
    padding-left: 20px;
  }
  .count-down-wrapper .tip span{
    font-weight: bold;
    color: #000;
  }
  .orderid-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 8px;
  }
  .orderid-box .order-id {
    font-size: 16px;
    color: #333;
  }
  .orderid-box .desc {
    font-size: 12px;
    color: #666;
    float: right;
  }
  .orderid-box .desc i {
    color: #f03d37;
    font-style: normal;
  }
  .order-table {
    width: 100%;
    border: 1px solid #e5e5e5;
    border-spacing: 0;
    margin-bottom: 60px;
  }
  .order-table thead {
    background-color: #f7f7f7;
  }
  .order-table thead th {
    font-size: 16px;
    color: #333;
    width: 25%;
    padding: 14px 0;
    font-weight: 400;
  }
  .order-table td {
    text-align: center;
    padding: 20px 0;
    color: #333;
  }
  .order-table .movie-name {
    font-size: 16px;
  }
  .order-table .showtime {
    font-size: 14px;
    color: #f03d37;
  }
  .order-table .cinema-name {
    font-size: 14px;
  }
  .order-table .hall {
    display: inline-block;
    font-size: 14px;
    color: #424242;
    font-weight: 700;
    margin-right: 10px;
  }
  .order-table .seats {
    display: inline-block;
    text-align: left;
  }
  .order-table .seats .seat{
    display: inline-block;
    padding-right: 2px;
  }
  .confirm-wrapper {
    text-align: right;
  }
  .confirm-wrapper .price-wrapper {
    font-size: 14px;
    color: #333;
    margin-bottom: 17px;
  }
  /*查看详情按钮*/
  .buy-btn {
    margin: 0 auto 17px auto;
    width: 80px;
    height: 45px;
    line-height: 45px;
    text-align: center;
  }
  .buy-btn .btn {
    display: block;
    height: 30px;
    line-height: 30px;
    color: #fff;
    background-color: #f03d37;
    font-size: 14px;
    border-radius: 100px;
    box-shadow: 0 2px 10px -2px #f03d37;
    cursor: pointer;
  }
  .confirm-wrapper .price-wrapper .prices {
    font-size: 24px;
    color: #f03d37;
  }
  .confirm-wrapper .price-wrapper .prices .price{
    font-size: 36px;
  }
  .btn-wrapper .btn {
    cursor: pointer;
    display: inline-block;
    width: 190px;
    height: 42px;
    line-height: 42px;
    text-align: center;
    color: #fff;
    background-color: #f03d37;
    border-radius: 100px;
    -webkit-box-shadow: 0 2px 10px -2px #f03d37;
    box-shadow: 0 2px 10px -2px #f03d37;
  }
</style>


// WEBPACK FOOTER //
// src/views/orderSuccess.vue